/**
 * Пункт списку поза меню типу (прототип v4 navGo з ключем пресета: «Показати прострочені» / «Показати без виконавця» порад і тайлів
 * відкривають список із пресетом, навіть коли в меню модуля такого пункту немає; пункт власного меню модуля з фільтром, якого меню типу
 * не має, — `where:<фільтр>`). Чисті функції.
 */
import type { IModuleStrings, IRecordTypeDefinition, PresetKey } from '@platform/core/types';
import type { IMenuEntry } from './IMenuEntry';

const PRESET = 'preset:';
const WHERE = 'where:';

/** Ключ пункту `?item=` для пресета (той самий, що й у пункту меню з цим пресетом: buildMenu). */
export function presetItemKey(preset: PresetKey): string {
  return `${PRESET}${preset}`;
}

/**
 * Підпис пресета поза меню: статус (`status:<значення>`) — підпис статусу модуля, інакше — рядок рушія `menu.presets.<ключ>` (переданий
 * перекладач `label`), а невідомий пресет — сам ключ.
 */
export function presetLabelOf(preset: string, rt: IRecordTypeDefinition, strings: IModuleStrings, label: (key: string) => string | undefined): string {
  if (preset.startsWith('status:')) {
    const value = preset.slice('status:'.length);
    return strings.status(rt.key, value, rt.statuses.list.find((s) => s.value === value)?.label ?? value);
  }
  return label(preset) ?? preset;
}

/** Ключ пункту `?item=` для фільтра поза меню типу (пункт власного меню модуля). */
export function whereItemKey(filter: string): string {
  return `${WHERE}${filter}`;
}

/**
 * Пункт для ключа `preset:<ключ>` з підписом `label` або `where:<фільтр>` з підписом `filterLabel` (без нього — сам фільтр); інший ключ —
 * undefined (подання відкриваються лише пунктами меню).
 */
export function adHocEntryOf(
  key: string | null | undefined, label: (preset: string) => string, filterLabel?: (filter: string) => string,
): IMenuEntry | undefined {
  if (key?.startsWith(WHERE) && key.length > WHERE.length) {
    const filter = key.slice(WHERE.length);
    return { key, label: filterLabel?.(filter) ?? filter, group: '', filter };
  }
  if (!key?.startsWith(PRESET) || key.length === PRESET.length) return undefined;
  const preset = key.slice(PRESET.length) as PresetKey;
  return { key, label: label(preset), group: '', preset, warning: preset === 'overdue' };
}
